import { ReactComponent as WhatsappIcon } from "../../images/icons/whatsapp.svg";
import { ReactComponent as AmazonIcon } from '../../images/icons/amazon.svg';
import { ReactComponent as FormIcon } from '../../images/icons/form.svg';
import { whatsAppLink } from "../../components/Buttons/Whatsapp/Whatsapp.js";
import "../Contact/Contact.css";
const formLink = `https://forms.gle/ewm77c94hukTPUo1A`;
const amazonLink = `https://www.amazon.com.br/hz/wishlist/ls/3BHB2LNHJP21N?ref_=wl_share`;

const Contact = () => {
  return (
    <div id="contact" className="d-flex flex-column justify-content-center bg-light">
      <div className="contact-container">
        <div className="titles">
          <h5 style={{ color: "#6D4C41", fontWeight:"normal" }}id="contact-title" className="title">Contato</h5>
          <h6 style={{ color: "#6D4C41", fontWeight:"normal" }}>contato@laynatambucci.com.br</h6>
        </div>
        <div className="buttons">
          <a href={whatsAppLink} target="_blank" rel="noopener noreferrer" className="button">
            <button className="bg-light" style={{ padding: '10px', color: "#6D4C41", border: "none", justifyContent: 'center', alignItems: 'center' }}>
              <WhatsappIcon title="Fale comigo no Whatsapp" alt="Ícone Whatsapp" style={{ fill: "#6D4C41", width: '30px', height: '30px', marginRight: '10px' }} className="whatsapp-icon" />
            </button>
          </a>
          <a href={formLink} target="_blank" rel="noopener noreferrer" className="button">
            <button className="bg-light" style={{ padding: "10px 20px", border: "none", borderRadius: "5px", cursor: "pointer" }}>
              <FormIcon title="Agende sua sessão" alt="Cadastro de Analisandos" style={{ fill: "#6D4C41", width: '30px', height: '30px' }} />
            </button>
          </a>
          <a href={amazonLink} target="_blank" rel="noopener noreferrer" className="button">
            <button className="bg-light" style={{ padding: '10px',  border: "none", justifyContent: 'center', alignItems: 'center' }}>
              <AmazonIcon title="Indicações de Leitura" alt="Ícone Amazon" style={{ fill: "#6D4C41", width: "30px", height: "30px" }} />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
